import { get, trim } from 'lodash';

class Seat {
  constructor() {
    this.seatMap = {
      section: 'SectionId',
      seat_row: 'SeatRow',
      seat_num: 'SeatNumber',
      seat_status: 'SeatStatusId',
      seat_no: 'Id',
      zone_no: 'ZoneId',
      ac_no: 'AllocationId',
      seat_type: 'SeatTypeId',
      logical_seat_row: 'LogicalSeatRow',
      logical_seat_num: 'LogicalSeatNumber',
      xpos: 'XPosition',
      ypos: 'YPosition',
      is_seat: 'IsSeat',
      aisle_ind: 'AisleIndicator',
      no_stairs_ind: 'HasStairs',
      display_letter: 'DisplayLetter',
      screen_no: 'ScreenId',
      hc_no: 'HoldCodeId'
    };
  }

  map(seats, brief = false) {
    let theSeats = [];
    for (let x = 0; x < seats.length; x++) {
      let seat = {};
      for (let p in this.seatMap) {
        seat[p] = trim(get(seats[x], this.seatMap[p]));
      }
      if (brief) {
        theSeats.push({ D: Object.values(seat).join(',') });
      } else {
        theSeats.push({ Seat: seat });
      }
    }

    return theSeats;
  }
}

export default Seat;



// WEBPACK FOOTER //
// ./src/javascripts/lib/tessitura/REST/maps/Seat.js